/**
 * Created by admin on 2017/9/22.
 */
//上传打印图片的service
{
    angular.module('utilsModule')
        .factory('utils.uploadImageManager', uploadImageManager);
    uploadImageManager.$inject = ['utils.constant', 'FileUploader', '$state','$timeout'];
    function uploadImageManager(constant, FileUploader, $state,$timeout) {
        let collect = {
            'uploader': null,
            'init': init,
            'callbackDelegateList': null,
            'u_image': {},
            'timer':null,
            'checkInterval':500,
            'currentFileItem':null,
        }

        function init() {
            /*if (collect.uploader) {
                console.log("collect.uploader",collect.uploader)
                return;
            }*/
            let uploader = collect.uploader = new FileUploader({
                url: constant.config.sitePath+constant.action.upload_imageprint,
                // formData:[{'a':0,'b':1}],
                alias: 'Filedata',//alias 别名
            });
            uploader.filters.push({
                name: 'imageFilter',
                fn: function (item /*{File|FileLikeObject}*/, options) {
                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
                }
            });

            // CALLBACKS
            function doCallback(funcName, ...args) {
                console.log('collect.callbackDelegateList',collect.callbackDelegateList);
                //console.log('doCallback',collect.callbackDelegateList.length);
                /*for (let i = 0; i < collect.callbackDelegateList.length; i++) {
                    //console.log(typeof(collect.callbackDelegateList[i].onProgressItem));
                    if (typeof(collect.callbackDelegateList[i][funcName]) == 'function') {
                        collect.callbackDelegateList[i][funcName](...args);
                    }
                }*/

                    //console.log(typeof(collect.callbackDelegateList[i].onProgressItem));
                    if (typeof(collect.callbackDelegateList[funcName]) == 'function') {
                        collect.callbackDelegateList[funcName](...args);
                    }

            }
            uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
                // console.info('onWhenAddingFileFailed', item, filter, options);
                doCallback('onWhenAddingFileFailed', item, filter, options);
            };
            uploader.onAfterAddingFile = function (fileItem) {
                // console.info('onAfterAddingFile', fileItem);
                // console.info(uploader.queue);
                collect.currentFileItem=fileItem;
                fileItem.upload();
                doCallback('onAfterAddingFile', fileItem);
            };
            uploader.onAfterAddingAll = function (addedFileItems) {
                // console.info('onAfterAddingAll', addedFileItems);
            };
            uploader.onBeforeUploadItem = function (item) {
                // console.info('onBeforeUploadItem', item);
            };
            uploader.onProgressItem = function (fileItem, progress) {
                // console.info('onProgressItem', fileItem, progress);
                doCallback('onProgressItem', fileItem, progress);
            };
            uploader.onProgressAll = function (progress) {
                // console.info('onProgressAll', progress);
            };
            uploader.onSuccessItem = function (fileItem, response, status, headers) {
                // console.info('onSuccessItem', fileItem, response, status, headers);
                console.log('response',response);
                console.log('fileItem:',fileItem);
                collect.u_image.name = response.name;
                collect.u_image.docid = response.docid;
                collect.u_image.path = constant.config.sitePath + constant.config.imgPrintPath + (response.docid+response.name);
                var img = document.createElement("img");
                document.getElementsByClassName('content_wrap')[0].appendChild(img);
                img.src = collect.u_image.path;
                img.style.visibility = 'hidden';
                function getImg() {
                    collect.u_image.imgWidth = img.naturalWidth;
                    collect.u_image.imgHeight = img.naturalHeight;
                    console.log("imgWidth:", collect.u_image.imgWidth);
                    console.log("imgHeight:", collect.u_image.imgHeight);
                    document.getElementsByClassName('content_wrap')[0].removeChild(img);
                }
                function checkImg() {
                    if (img.naturalWidth > 0) {
                        getImg();
                        console.log("uploader:",collect.uploader);
                        doCallback('onSuccessItem', fileItem, response, status, headers);
                        $timeout.cancel(collect.timer);
                    } else {
                        collect.timer=$timeout(checkImg,collect.checkInterval)
                    }
                }
                checkImg();
                collect.currentFileItem=fileItem;
            };
            uploader.onErrorItem = function (fileItem, response, status, headers) {
                 //console.info('onErrorItem', fileItem, response, status, headers);

                doCallback('onErrorItem', fileItem, response, status, headers);
            };
            uploader.onCancelItem = function (fileItem, response, status, headers) {
                // console.info('onCancelItem', fileItem, response, status, headers);

                doCallback('onCancelItem', fileItem, response, status, headers);
            };
            uploader.onCompleteItem = function (fileItem, response, status, headers) {
                // console.info('onCompleteItem', fileItem, response, status, headers);
            };
            uploader.onCompleteAll = function () {
                // console.info('onCompleteAll');
            };

            // console.info('uploader', uploader);
        }


        return collect;
    }

}